import React from "react"
import { AppToolbarCreateButton } from "@components"
import { reportFormDataInnit } from "Pages/ReportsAlerts/Reports/@signals"


export default function ReportTableCreateReportButton() {
	return <AppToolbarCreateButton
		data-tour-id="tour-create-report"
		divider={false}
		label="Create Report"
		icon="file-plus"
		onClick={() => reportFormDataInnit()}
	/>
}
